import { render, staticRenderFns } from "./OrderReceived.vue?vue&type=template&id=c75b7786"
import script from "./OrderReceived.vue?vue&type=script&lang=js"
export * from "./OrderReceived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports